import Button from "./common/Button";
import CheckBox from "./common/Checkbox";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";
import { useEffect, useState } from "react";
import ModifyTracking from "./ModifyTracking";
import { usePostTmpList } from "../../../../hooks/morning/usePostTmpList";
import { useDeleteTmp } from "../../../../hooks/morning/useDeleteTmp";
import ModalPortal from "../../../../components/ui/ModalPortal";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { createPortal } from "react-dom";
import { toast } from "react-hot-toast";

type OrderListProps = {
    onSelectRowsChange: (rows: number[]) => void;
    id?: string;
    code: string;
    infoData?: any;
};

const OrderList = ({ onSelectRowsChange, id, code, infoData }: OrderListProps) => {
    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [trackingShow, setTrackingShow] = useState(false);
    const [selectedTrackingIdx, setSelectedTrackingIdx] = useState<string>("");
    const [showConfirmDeletePop, setShowConfirmDeletePop] = useState<{ open: boolean; type: "selected" | "all" | null }>({
        open: false,
        type: null,
    });

    const { data: historyData } = usePostTmpList(code);
    const { mutate: deleteTmp } = useDeleteTmp(() => {
        setSelectedRows([]);
        setSelectAll(false);
    });

    const handleToggleAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(historyData?.map(item => Number(item.idx)) || []);
        }
        setSelectAll(!selectAll);
    };

    const handleToggleRow = (id: number) => {
        setSelectedRows(prev => (prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]));
    };

    const handleDeleteSelected = () => {
        deleteTmp({ idx: selectedRows });
    };

    const handleDeleteAll = () => {
        const allIdx = historyData?.map(item => Number(item.idx)) || [];
        deleteTmp({ idx: allIdx });
    };

    useEffect(() => {
        onSelectRowsChange(selectedRows);
    }, [selectedRows, onSelectRowsChange]);

    useEffect(() => {
        if (historyData) {
            const allIdx = historyData.map(item => Number(item.idx));
            setSelectedRows(allIdx);
            setSelectAll(true);
        }
    }, [historyData]);

    const handleConfirmDelete = (type: "selected" | "all") => {
        if (type === "selected") {
            if (selectedRows.length === 0) {
                return;
            }

            setShowConfirmDeletePop({ open: true, type: "selected" });
        } else {
            setShowConfirmDeletePop({ open: true, type: "all" });
        }
    };

    return (
        <div id={id} className="bg-white w-full max-w-[1200px] rounded-2xl p-10 responsive1200:px-[16px]">
            <div className="border-b-[2px] text-[#1b1c1e] gap-3 border-black flex items-center pb-2">
                <p className="text-[28px] font-bold responsive1200:text-[20px]">오더접수 목록</p>
                <p className="text-[20px] font-semibold">
                    총 <span className="text-new">{historyData?.length || 0}</span> 건
                </p>
            </div>
            <div className="flex items-center justify-between mt-3 mb-2">
                <p className="font-semibold">
                    선택 <span className="text-new">{selectedRows.length}</span> 건
                </p>
                <div className="flex gap-1">
                    <Button className="text-[#878a93] bg-[#f3f5f8] border-none" onClick={() => handleConfirmDelete("selected")}>
                        선택삭제
                    </Button>
                    <Button className="text-white bg-[#ff4242] border-none" onClick={() => handleConfirmDelete("all")}>
                        전체삭제
                    </Button>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full mt-2.5 min-w-[900px]">
                    <thead>
                        <tr className="border-b border-gray-200 h-11 bg-[#F7F7F8]">
                            <th className="w-[80px] flex h-11 justify-center ">
                                <CheckBox checked={selectAll} onChange={handleToggleAll} />
                            </th>
                            <th className="w-[120px] font-normal">발송 및 지불</th>
                            <th className="w-[326px] bg-[#70737C14] font-[500]">출발지</th>
                            <th>
                                <RightArrow />
                            </th>
                            <th className="w-[326px] bg-[#70737C14] font-[500]">도착지</th>
                            <th className="w-[100px] font-normal">수량</th>
                            <th className="w-[140px] font-normal">운송장 수정</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyData?.map(item => (
                            <tr key={item.idx} className="border-b text-center h-[72px]">
                                <td className="flex justify-center items-center">
                                    <div className="translate-y-2.5">
                                        <CheckBox
                                            checked={selectedRows.includes(Number(item.idx))}
                                            onChange={() => handleToggleRow(Number(item.idx))}
                                        />
                                    </div>
                                </td>
                                <td className="text-[18px] font-bold">{item.s_kind}</td>
                                <td className="text-[16px] text-left px-4">
                                    <div className="flex items-center gap-2">
                                        <p className="min-w-[120px] text-center">{item.f_company}</p>
                                        <p className="">{item.f_address}</p>
                                    </div>
                                </td>
                                <td>
                                    <RightArrow />
                                </td>
                                <td className="text-[16px] text-left px-4">
                                    <div className="flex items-center gap-2">
                                        <p className="min-w-[120px] text-center">{item.t_company}</p>
                                        <p className="">{item.t_address}</p>
                                    </div>
                                </td>
                                <td className="text-[#5A5C63] font-semibold">{item.s_cnt} 건</td>
                                <td className="flex justify-center h-[72px] items-center">
                                    <Button
                                        onClick={() => {
                                            setSelectedTrackingIdx(item.idx);
                                            setTrackingShow(true);
                                        }}
                                    >
                                        운송장 수정
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showConfirmDeletePop.open &&
                createPortal(
                    <div className="fixed inset-0 z-[300] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute text-[#1b1c1e] z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-full max-w-[560px] responsive700:max-w-[85%] responsive700:p-5 p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p className="font-[600]">{showConfirmDeletePop.type === "selected" ? "선택 삭제" : "전체 삭제"}</p>
                                <Close onClick={() => setShowConfirmDeletePop({ open: false, type: null })} className="cursor-pointer" />
                            </div>
                            <p className="text-lg">
                                {showConfirmDeletePop.type === "selected" ? "선택한 항목을 삭제 하시겠습니까?" : "전체 삭제 하시겠습니까?"}
                            </p>
                            <Button
                                onClick={() => {
                                    if (showConfirmDeletePop.type === "selected") {
                                        handleDeleteSelected();
                                    } else {
                                        handleDeleteAll();
                                    }
                                    setShowConfirmDeletePop({ open: false, type: null });
                                }}
                                className="w-full border-none bg-new text-white"
                                size="L"
                            >
                                확인
                            </Button>
                        </div>
                    </div>,
                    document.getElementById("confirm-delete-pop-root")!,
                )}

            {trackingShow && (
                <ModalPortal>
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="bg-white overflow-auto rounded-2xl relative max-h-[90vh]">
                            <ModifyTracking
                                infoData={infoData}
                                idx={selectedTrackingIdx}
                                onClose={() => setTrackingShow(false)}
                                className="mx-0"
                            />
                        </div>
                    </div>
                </ModalPortal>
            )}
        </div>
    );
};

export default OrderList;
